import * as React from "react";
import { AssetClassType } from "../../../../../../../../Wrap/Constants/Enums/Domain/Instrument/AssetClassType";
import { MPSType } from "../../../../../../../../Wrap/Constants/Enums/Domain/Instrument/MPSType";
import { PerformanceMethod } from "../../../../../../../../Wrap/Constants/Enums/Domain/PerformanceMethod";
import { ViewType } from "../../../../../../../../Wrap/Constants/Enums/Portfolio/Investments/ViewType";
import { ReportContent } from "../../../../../../../../Wrap/Constants/Enums/Report/ReportContent";
import { ReportIntroduction } from "../../../../../../../../Wrap/Constants/Enums/Report/ReportIntroduction";
import { ClientAccount } from "../../../../../../../../Wrap/Models/Domains/Account/SlAccounts/ClientAccount";
import { ReportBuilder as ReportBuilderModel } from "../../../../../../../../Wrap/Models/Models/Reports/ReportBuilder";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../../Shared/Process/Process/ProcessComponent";
import { getQueryParameters } from "../../../../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { countNewLines } from "../../../../Common/Helpers/TextInputHelper";
import { ContentSettings } from "./ContentSettings";
import { Perference } from "./Perference";
import { Setup } from "./Setup";

interface IReportBuilderProps extends IProcessComponentProps {
    onGenerate: (data: ReportBuilderModel) => void;
    data: ClientAccount;
}

interface IReportBuilderState {
    settings: ReportBuilderModel;
}

export class ReportBuilder extends ProcessComponent<IReportBuilderProps, IReportBuilderState> {
    constructor(props: IReportBuilderProps) {
        super(props);
        this.state = {
            settings: {
                AccountHierarchyId: getQueryParameters()["hierarchyid"],
                SubAccounts: [],
                ReportContents: [
                    ReportContent.ReportIntroduction,
                    ReportContent.AccountDetails,
                    ReportContent.Snapshot,
                    ReportContent.Valuation,
                    ReportContent.Performance,
                ],
                ReportInsights: [],
                ReportPerformanceGraphs: [],
                ReportTransactions: [],
                ReportIntroductions: [ReportIntroduction.CoverPage, ReportIntroduction.ContentsPage],
                BenchmarkList: [],
                PerformanceMethod: PerformanceMethod.Simple,
                ViewType: ViewType.Product,
                AssetClassType: AssetClassType.NoAssetClass,
                MPSType: MPSType.MPSDetails,
            },
        };
    }

    private onSettingsChange(changes) {
        const { settings } = this.state;
        for (const key in changes) {
            settings[key] = changes[key];
        }

        console.log(settings);
        this.setState({ settings: settings });
    }

    private getProps() {
        const { settings } = this.state;
        const { data } = this.props;
        return {
            data: settings,
            onChange: (changes) => this.onSettingsChange(changes),
            onRef: (ref) => this.appendChild(ref),
            clientAccount: data,
        };
    }

    render() {
        return (
            <>
                <Setup {...this.getProps()} />
                {this.state.settings?.ReportView && this.state.settings?.ReportFormat && (
                    <>
                        <ContentSettings {...this.getProps()} />
                        <Perference {...this.getProps()} />
                    </>
                )}

                <button
                    className="btn primary"
                    onClick={() => {
                        if (this.isValid()) {
                            const settings = { ...this.state.settings };
                            if (settings.Commentary) {
                                const newLines = countNewLines(settings.Commentary);
                                if (newLines.count > 0) {
                                    // replace new line character with #
                                    settings.Commentary = settings.Commentary.split(newLines.newLineCharacters).join(
                                        "#"
                                    );
                                }
                            }

                            this.props.onGenerate(settings);
                        }
                    }}
                >
                    Create report
                </button>
            </>
        );
    }
}
